/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Text from 'components/Text.jsx';
import Link from 'components/Link.jsx';
import Button from 'components/Button.jsx';

import './styles/AdminBillingBanner.scss';

type Props = {
  organizationId: number,
  organization?: { paid: boolean, type: string },
}

function _AdminBillingBanner(props: Props) {
  if (!props.organization || props.organization.paid) {
    return null;
  }

  const link = props.organization.type === 'School'
    ? `/admin/schools/${props.organizationId}/billing/overview`
    : `/admin/districts/${props.organizationId}/billing/overview`;

  return (
    <div className="AdminBillingBanner">
      <div className="AdminBillingBanner-content">
        <Text element="div" size="xlarge">Manage your community and gain powerful insight.</Text>
        <Text element="div" size="large">
          The Admin Console is a premium feature for connected schools and districts.
          Click below to learn more.
        </Text>
        <Text>
          <Link to={link}>
            <Button inline color="white">
              Get the Admin Console
            </Button>
          </Link>
        </Text>
        <Link to="/classes" color="white">Go to Remind</Link>
      </div>
    </div>
  );
}

const AdminBillingBanner = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      paid
      type
    }
  }`,
  {
    options: ({ organizationId }) => ({ variables: { organizationId: [organizationId] } }),
    props: ({ data }) => ({ organization: data.organizations ? data.organizations[0] : null }),
  }
)(_AdminBillingBanner);

function AdminBillingBannerWrapper(_props: any, context: any) {
  const { router } = context;
  const { schoolId, districtId } = router.params;

  return <AdminBillingBanner organizationId={Number(schoolId || districtId)} />;
}

AdminBillingBannerWrapper.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export { _AdminBillingBanner as AdminBillingBanner };
export default AdminBillingBannerWrapper;



// WEBPACK FOOTER //
// ./src/admin/components/AdminBillingBanner.jsx